import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-quote-step5-desktop',
  templateUrl: './quote-step5-desktop.component.html',
  styleUrls: ['./quote-step5-desktop.component.css']
})
export class QuoteStep5DesktopComponent implements OnInit {
  @Input()
  vectorsrc13: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/7c9bc80b-20a9-4029-9ab3-1daa79d16e9e?org_if_sml=1222&force_format=original'
  @Input()
  inputplaceholder2: string = 'Costa Rica'
  @Input()
  vectorsrc11: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/8c8637e9-9d35-4ddd-8c6f-b2174060e37f?org_if_sml=1743&force_format=original'
  @Input()
  ellipse25src1: string = '/assets/external/ellipse253371-7apm.svg'
  @Input()
  vectoralt1: string = 'Vector3371'
  @Input()
  vectorsrc: string = '/assets/external/vector3371-3bho.svg'
  @Input()
  vectoralt8: string = 'VectorI3387'
  @Input()
  inputplaceholder1: string = 'Amador'
  @Input()
  vectoralt3: string = 'Vector3371'
  @Input()
  vectoralt11: string = 'VectorI3387'
  @Input()
  vectoralt4: string = 'Vector3371'
  @Input()
  vectoralt2: string = 'Vector3371'
  @Input()
  vectoralt9: string = 'VectorI3387'
  @Input()
  vectoralt7: string = 'VectorI3387'
  @Input()
  ellipse25src4: string = '/assets/external/ellipse253371-mv7.svg'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f9f71c5e-489a-48cb-8c36-da40750caac2?org_if_sml=1521&force_format=original'
  @Input()
  vectoralt: string = 'Vector3371'
  @Input()
  vectoralt6: string = 'VectorI3387'
  @Input()
  vectorsrc1: string = '/assets/external/vector3371-0of.svg'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/1eebf9f7-f477-4e09-ab4b-1ba57c7fab63?org_if_sml=1502&force_format=original'
  @Input()
  vectoralt14: string = 'VectorI3387'
  @Input()
  vectorsrc12: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/960a552c-d960-49c5-bd9b-7ffaefd98667?org_if_sml=1743&force_format=original'
  @Input()
  vectoralt15: string = 'VectorI3387'
  @Input()
  ellipse25alt: string = 'Ellipse253371'
  @Input()
  vectorsrc2: string = '/assets/external/vector3371-a9re.svg'
  @Input()
  vectoralt5: string = 'VectorI3387'
  @Input()
  vectorsrc15: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/1d8ad635-3774-4e76-b048-23270e139f5f?org_if_sml=1490&force_format=original'
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/25861a0d-721e-4a0c-8a58-00237115a0e5?org_if_sml=1171&force_format=original'
  @Input()
  inputplaceholder: string = 'Andrea'
  @Input()
  ellipse25alt4: string = 'Ellipse253371'
  @Input()
  ellipse25alt3: string = 'Ellipse253371'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/9594682a-0b00-4dbf-8d86-c5c7f887f269?org_if_sml=11330&force_format=original'
  @Input()
  ellipse25src3: string = '/assets/external/ellipse253371-y6ld.svg'
  @Input()
  vectoralt12: string = 'VectorI3387'
  @Input()
  vectoralt13: string = 'VectorI3387'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/34cf6d5c-8987-4222-9e64-49f59d136106?org_if_sml=1624&force_format=original'
  @Input()
  rootClassName: string = ''
  @Input()
  vectorsrc4: string = '/assets/external/vector3371-qnkq.svg'
  @Input()
  ellipse25src2: string = '/assets/external/ellipse253371-inj.svg'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/c62c269f-338a-49e8-9a6d-3c5ba9809bca?org_if_sml=1633&force_format=original'
  @Input()
  ellipse25alt1: string = 'Ellipse253371'
  @Input()
  vectoralt10: string = 'VectorI3387'
  @Input()
  ellipse25alt2: string = 'Ellipse253371'
  @Input()
  vectorsrc3: string = '/assets/external/vector3371-kml.svg'
  @Input()
  vectorsrc14: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/3344d2eb-9a8c-4a15-aa53-0490a733b74c?org_if_sml=1740&force_format=original'
  @Input()
  ellipse25src: string = '/assets/external/ellipse253371-mu2f.svg'
  rawjde1: string = ' '

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  
  ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  ballBlueSmall: string = '/assets/external/ballbluesmall-resize.png'
  towerNew: string = '/assets/external/tower-new-resize.png'
  constructor() {}

  nextStep(): void {
		 this.onNextStep.emit(this.currentStep);
	}

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
 }
  ngOnInit() {
  }

}
